import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticlePreview() {
  const list = articles.slice(0, 3);

  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">最新评测推荐</h2>
            <p className="mt-2 text-sm text-foreground-600">围绕漫画软件应用的排行、免费与正版追更，持续输出实用内容</p>
          </div>
          <Link to="/reviews" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-bold text-primary-600 transition-colors hover:text-primary-700">
            查看全部评测
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {list.map((a) => (
            <article key={a.id} className="group flex flex-col overflow-hidden rounded-2xl border border-background-200/80 bg-background-50 transition-transform duration-300 hover:-translate-y-1">
              <Link to={`/reviews/${a.id}`} className="block overflow-hidden">
                <div className="aspect-[16/9] w-full overflow-hidden bg-background-200">
                  <img
                    src={a.cover}
                    alt={a.title}
                    title={a.title}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              </Link>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className="whitespace-nowrap rounded-md bg-secondary-100 px-2 py-0.5 text-secondary-900">{a.category}</span>
                  <span>{a.date}</span>
                  <span>·</span>
                  <span>{a.readTime}</span>
                </div>
                <h3 className="mt-3 line-clamp-2 text-base font-bold text-foreground-950">
                  <Link to={`/reviews/${a.id}`} className="transition-colors hover:text-primary-600">{a.title}</Link>
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-700">{a.excerpt}</p>
                <div className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className="ri-user-smile-line" aria-hidden="true"></i>
                  </span>
                  {a.author}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}